<template>
    <div class='clearfix pageTemp'>
        <el-pagination
            class='rt'
            background
            @current-change="changePage"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="jumper,prev, pager,next"
            prev-text='上一页'
            next-text='下一页'
            :total="total">
        </el-pagination>
        <p class='rt' v-if='total'>第{{currentPage}} / {{Math.ceil(total/pageSize)}}页 共{{total}}条</p>
    </div>
</template>
<script>
export default {
    name:'Pagination',
    props:{
        total:{
            type:Number,
            default:0,
            required:true
        },
        pageSize:{
            type:Number,
            default:10,
            required:true
        },
        currentPage:{
            type:Number,
            default:1,
            required:true
        },
    },
    data(){
        return{

        }
    },
    methods:{
        changePage(val){
            this.$emit('changePage',val)
        }
    }
}
</script>
<style lang="scss">
    .pageTemp{
        padding:5px 0;
        >p.rt{
            // margin-top: 10px;
            line-height: 32px;
            margin-right:20px;
            color:#999;
        }
        .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev{
            min-width: 54px;
        }
        
    }
</style>
